import {
  GatsbyImage,
  getImage,
} from "gatsby-plugin-image";
import React, { CSSProperties } from "react";

export const LimaImage: React.FC<{
  image: ImageDataOrPublicURL | null;
  alt?: string;
  className?: string;
  cover?: boolean;
  objectFit?: CSSProperties["objectFit"];
}> = ({ image, alt, className = "", cover, objectFit = "cover", ...props }) => {
  if (!image) return null;
  if (image.publicURL) {
    if (cover) {
      return (
        <div
          className={`w-full bg-cover bg-center ${className}`}
          style={{ backgroundImage: "url(" + image.publicURL + ")" }}
          {...props}
        />
      );
    } else {
      return (
        <img
          src={image.publicURL}
          alt={alt ? alt : ""}
          className={`w-full ${className}`}
        />
      );
    }
  } else if (image.imageData)
    return (
      <GatsbyImage
        image={image.imageData}
        alt={alt ? alt : ""}
        className={className}
        objectFit={objectFit}
        {...props}
      />
    );
  return null;
};

export const getImageDataOrPublicURL: (
  image: ImageDataLikeWithPropsForGifs | null,
) => ImageDataOrPublicURL | null = (image) => {
  if (!image) return null;
  if (["gif", "svg"].includes(image.extension || ""))
    return { publicURL: image.publicURL, imageData: null };
  return { publicURL: null, imageData: getImage(image) };
};
